// extracted by mini-css-extract-plugin
module.exports = {"container":"SunnyNav_container__18unQ","collapsed":"SunnyNav_collapsed__sz1zD"};